import { Button } from "components/button/Button/Button";
import React from "react";
import { StyledDialogHeader } from "./style";
import { useDialogContext } from "../controller/DialogProvider";
import { useDialogOverlayContext } from "../controller/DialogOverlay";

interface DialogHeaderProps {
  children: React.ReactNode;
}

export const DialogHeader = ({ children }: DialogHeaderProps) => {
  const { $size, $preventClose } = useDialogOverlayContext();
  const { closeDialog } = useDialogContext();

  return (
    <StyledDialogHeader $size={$size}>
      <p>{children}</p>
      {!$preventClose && (
        <Button
          size={$size === "small" ? "medium" : "large"}
          preIcon="XCloseMd"
          color="strong"
          type="text"
          onClick={closeDialog}
        />
      )}
    </StyledDialogHeader>
  );
};
